module.exports = __webpack_public_path__ + "img/bar-arrow@2x.4e076786.png";